<mat-card>
  <!-- HEADER -->
  <div class="panel-request__card-header" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <h2
      translate
      [translateParams]="{ description: tableRow.articleDescription, percent: tableRow.percentInTotalInversion }"
    >
      generalOfInvestment.title
    </h2>
  </div>

  <!-- CONTENT -->
  <mat-card-content>
    <div class="table__wrapper">
      <!-- TABLE -->
      <table aria-label="investment-table" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="calification">
          <th mat-header-cell *matHeaderCellDef translate>generalOfInvestment.calification</th>
          <td mat-cell *matCellDef="let element" class="first-column">
            {{ element.sectorId }} - {{ element.serctorDescription }}
          </td>
          <td mat-footer-cell *matFooterCellDef class="first-column bold" translate>generalOfInvestment.totals</td>
        </ng-container>
        <ng-container matColumnDef="operationNumber">
          <th mat-header-cell *matHeaderCellDef translate>generalOfInvestment.numOperations</th>
          <td mat-cell *matCellDef="let element">{{ element.numOperations }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ tableRow.numOperations }}</td>
        </ng-container>
        <ng-container matColumnDef="investment">
          <th mat-header-cell *matHeaderCellDef translate>generalOfInvestment.investment</th>
          <td mat-cell *matCellDef="let element">{{ element.inversion | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ tableRow.inversion | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="percentageOverTotal">
          <th mat-header-cell *matHeaderCellDef translate>generalOfInvestment.percentageOverTotal</th>
          <td mat-cell *matCellDef="let element">{{ element.totalPortion | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="averagePl">
          <th mat-header-cell *matHeaderCellDef translate>generalOfInvestment.averagePl</th>
          <td mat-cell *matCellDef="let element">{{ element.termsAverage | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef>{{ tableRow.termsAverage | transformNumber }}</td>
        </ng-container>
        <ng-container matColumnDef="averageTIR">
          <th mat-header-cell *matHeaderCellDef translate>generalOfInvestment.averageTIR</th>
          <td mat-cell *matCellDef="let element">{{ element.tirAverage | transformNumber }}</td>
          <td mat-footer-cell class="last-column" *matFooterCellDef>{{ tableRow.tirAverage | transformNumber }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
